import styled from 'styled-components'
import { fadeIn } from 'constants/keyframes/fades'
import { sequencedAnimationDelay } from 'helpers/styleHelpers/styleHelpers'
import { media } from 'constants/media/media'

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
`

export const ListWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
	column-gap: 1.8rem;
	${media.mobileOnly`
    	grid-row-gap: 2rem;
	`}
`

export const ListColumn = styled.div`
	width: 100%;
	max-width: 35rem;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 5rem;
	opacity: 0;
	animation: ${fadeIn} 400ms linear forwards;
	${sequencedAnimationDelay(30, 0.02)};
`
